import { type ReactNode } from 'react';
import { Target } from 'lucide-react';
import type { Cfg } from '../hooks/use-settings-state';
import { SettingsCard } from './settings-card';
import { GoalFields, Top3Fields, PeriodFields } from './settings-goals-fields';
import { RaceSection } from './settings-race-fields';
import { GroupBonusTiersSection } from './settings-group-tiers';

type Set = (k: keyof Cfg, v: string | number | boolean) => void;
const DIV = 'col-span-full my-xs border-t border-white/[0.06]';

export function GoalsCard({ cfg, set }: { cfg: Cfg; set: Set }): ReactNode {
  return (
    <SettingsCard
      icon={<Target size={16} />}
      title="Objetivos y bonificaciones"
      subtitle="Goals del equipo, ranking TOP 3 y bonus de velocidad"
    >
      <GoalFields cfg={cfg} set={set} />
      <div className={DIV} />
      <Top3Fields cfg={cfg} set={set} />
      <PeriodFields cfg={cfg} set={set} />
      <div className={DIV} />
      <GroupBonusTiersSection />
      <div className={DIV} />
      <RaceSection cfg={cfg} set={set} />
    </SettingsCard>
  );
}
